<page-toolbar [title]="'pages.content-pool' | translate"></page-toolbar>

<page-content>
  <data-table [plainData]="dynamicContentTypes" [columns]="columns" [hideSearch]="true" [noCard]="true"
              [limit]="dynamicContentTypes?.length" [noFooter]="true" (detail)="openType($event)"></data-table>
</page-content>
